module.exports = __webpack_public_path__ + "img/popup_option1.9ed382e.png";